<template>
  <div v-if="paginate.data != null && paginate.data.length > 0" class="row pagination align-items-center">
    <div class="col-sm-12 col-md-5 col-lg-5">
        {{
          $t('pagination.show_result', {
            'start': paginate.from === "null" || paginate.from == null ? 0 : paginate.from,
            'end': paginate.to === "null" || paginate.to == null ? 0 : paginate.to,
            'total': paginate.total === "null" || paginate.total == null ? 0 : paginate.total
          })
        }}
    </div>

    <div class="col-sm-12 col-md-5 col-lg-6">
      <ul class="pagination mb-0">
          <li
              :class="{'disabled': !(Number(paginate.current_page) === 1)}"
              class="paginate_button page-item previous disabled"
          >
            <a aria-controls="users-list-datatable"
               class="page-link"
               href="#"
               @click.prevent="changePageNumberDirect(paginate.current_page - 1)">{{  $t('general.previous') }}</a>
          </li>

          <li v-for="(link, index) in paginate.links" v-if="!((index === 0) || (index === paginate.links.length - 1))"
              class="paginate_button page-ite">
            <a class="page-link"
               :class="{'active': +paginate.current_page === +link.label}"
               href="#" @click.prevent="changePageNumber(link.url)">
              {{ link.label }}</a>
          </li>

          <li :class="{'disabled': (Number(paginate.current_page) >= Number(paginate.last_page))}"
              class="paginate_button page-item next">
            <a
                aria-controls="users-list-datatable"
                class="page-link"
                href="#"
                @click.prevent="changePageNumberDirect(paginate.current_page + 1)">{{  $t('general.next') }}</a></li>
        </ul>
    </div>


    <div class="col-sm-12 col-md-2 col-lg-1">
      <select v-model="perPageProxy" aria-controls="users-list-datatable"
               class="custom-select form-control"
               name="users-list-datatable_length">

        <option v-for="limit in itemsPerPage" :key="limit" :value="limit">{{ limit }}</option>
      </select>
    </div>
  </div>

</template>

<script>
export default {
  name: "pagination",
  props: {
    paginate: {
      default: {}
    },
    perPage: {
      default: 1,
    },
    page: {
      default: 1,
    },
    itemsPerPage: {
      default: function () {
        return [1, 10, 20, 30, 40, 50]
      },
    },
  },
  methods: {
    changePageNumber(url) {
      if (url == null || url === "null") return;
      let page_number = url.split("page=").pop();
      if (Number(this.paginate.current_page) !== Number(page_number)) {
        this.$emit('update:page', page_number);
      }
    },
    changePageNumberDirect(page) {
      let currentPage = null;
      if (page < 1) {
        currentPage = 1;
      } else if (page > this.paginate.last_page) {
        currentPage = this.paginate.last_page;
      } else {
        currentPage = page;
      }
      if (this.paginate.current_page !== currentPage) {
        this.$emit('update:page', currentPage);
      }
    }
  },
  computed: {
    perPageProxy: {
      set(value) {
        this.$emit('update:perPage', value)
      },
      get() {
        return this.perPage;
      },
    }
  },
}
</script>

<style scoped>

.active {
  border-radius: 0.267rem;
  background-color: #5A8DEE !important;
  color: #FFFFFF;
}
/*   Pagination css  */
/*------------------*/
.pagination .page-item.previous .page-link, .pagination .page-item.next .page-link, .pagination .page-item.first .page-link, .pagination .page-item.last .page-link {
  color: #5A8DEE;
  padding: 0.435rem 0.5rem;
}

.pagination .page-item.previous.disabled .page-link, .pagination .page-item.next.disabled .page-link, .pagination .page-item.first.disabled .page-link, .pagination .page-item.last.disabled .page-link {
  background-color: #F2F4F4;
}

.pagination .page-item:first-child .page-link {
  border-left: 1px solid #DFE3E7;
}

.pagination .page-item:last-child .page-link {
  border-right: 1px solid #DFE3E7;
}

.pagination .page-item .page-link {
  /* page link customization */
  border: 1px solid #DFE3E7;
  border-right: 0;
  border-left: 0;
  color: #324356;
  background-color: transparent;
  font-weight: 600;
}

.pagination .page-item .page-link:focus {
  box-shadow: none;
}

.pagination .page-item .page-link:hover {
  border-radius: 0.267rem;
  background-color: rgba(90, 141, 238, 0.2);
}

.pagination .page-item .page-link i {
  font-weight: 600;
  vertical-align: middle;
}

.pagination .page-item.active {
  border-radius: 0;
}

.pagination .page-item.active .page-link,
.pagination .page-item.active .page-link:hover {
  border-radius: 0.267rem;
  background-color: #5A8DEE !important;
  color: #FFFFFF;
}

.pagination .page-item.previous {
  margin-right: .3571rem;
}

.pagination .page-item.previous .page-link {
  border: 1px solid #DFE3E7;
  border-radius: 0.267rem;
}

.pagination .page-item.previous ~ .page-item:nth-child(2) .page-link {
  /* 1st page-item after "prev" button */
  border-left: 1px solid #DFE3E7;
  border-top-left-radius: 0.267rem;
  border-bottom-left-radius: 0.267rem;
}

.pagination .page-item.previous ~ .page-item:nth-last-child(-n+2) .page-link {
  /* last page-item previous of "Next" button */
  border-right: 1px solid #DFE3E7;
  border-top-right-radius: 0.267rem;
  border-bottom-right-radius: 0.267rem;
}

.pagination .page-item.next {
  margin-left: .3571rem;
}

.pagination .page-item.next .page-link {
  border: 1px solid #DFE3E7;
  border-radius: 0.267rem;
}

.pagination.pagination-borderless .page-item .page-link {
  /* Borderless Pagination */
  border: none !important;
}

.pagination.pagination-borderless .page-item.previous .page-link, .pagination.pagination-borderless .page-item.next .page-link {
  background-color: #DFE3E7;
}

.pagination.pagination-borderless .page-item.previous .page-link:hover, .pagination.pagination-borderless .page-item.next .page-link:hover {
  background-color: rgba(90, 141, 238, 0.2);
}

.pagination.pagination-borderless .page-item.previous.disabled .page-link, .pagination.pagination-borderless .page-item.next.disabled .page-link {
  background-color: #F2F4F4;
}

.pagination.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.267rem;
  border-bottom-left-radius: 0.267rem;
}

.pagination.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.267rem;
  border-bottom-right-radius: 0.267rem;
}

.page-link:hover {
  color: #fff !important;
  background-color: #475f7b !important;
  border-color: #475f7b !important;
  border-radius: 0.267rem !important;
}

</style>
